export const LOGIN_WITH_FACEBOOK = "LOGIN_WITH_FACEBOOK";
export const LOGIN_WITH_FACEBOOK_SUCCESSFUL = "LOGIN_WITH_FACEBOOK_SUCCESSFUL";
export const LOGIN_WITH_FACEBOOK_FAILED = "LOGIN_WITH_FACEBOOK_FAILED";
export const LOGIN_WITH_FACEBOOK_RESET_STATE = "LOGIN_WITH_FACEBOOK_RESET_STATE"; 
